export const AC_SET_LOADING = "AC_SET_LOADING";
export const AC_SET_ERROR = "AC_SET_ERROR";

export const AC_SET_TOOLS = "AC_SET_TOOLS";
export const AC_SET_MCP_SERVERS = "AC_SET_MCP_SERVERS";
export const AC_SET_RESOURCES = "AC_SET_RESOURCES";

export const AC_RESET = "AC_RESET";
